import KeyWordLocalization from "../../../../presentation/utils/KeyWordLocalization";

const getCurrentThemeApiImpl = (key: string, attrName: string): string => {
    let theme = localStorage.getItem(key);
    if(!theme) theme = KeyWordLocalization.ChangeThemeUseCaseDark;
    if ( theme == KeyWordLocalization.ChangeThemeUseCaseSystem) {
        //get theme from computer
        theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? KeyWordLocalization.ChangeThemeUseCaseDark: KeyWordLocalization.ChangeThemeUseCaseLight;
    }
    //set document body theme
    const reduced = theme?.replace(KeyWordLocalization.ChangeThemeUseCase, '').toLowerCase();
    document.body.setAttribute(attrName, reduced);
    console.log('theme', theme);
    return theme;
}

export default getCurrentThemeApiImpl;